export default __webpack_public_path__ + "static/media/undertow.8612a067.svg";